export enum ApiResource {
  Admin = 'admin',
  Games = 'games',
  Matches = 'matches',
  GameSessions = 'game-sessions',
  Notifications = 'notifications',
  Tournaments = 'tournaments',
  GameActivity = 'game-activity',
  Bracket = 'bracket',
  Users = 'users',
  Account = 'account',
  UserConnections = 'users/connections',
  Connections = 'connections',
  Payments = 'payments',
  PaymentUserQuotas = 'payments/users/quotas',
  Uploads = 'uploads',
  Feedbacks = 'feedbacks',
  Leaderboards = 'leaderboards',
  GameStatistics = 'game-statistics',
  PrizesAndDistribution = 'tournaments/prizes-and-distribution',
  AffiliatePrograms = 'affiliate-programs',
}
